import React from 'react';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Skeleton from '@mui/material/Skeleton';
import Slide from '@mui/material/Slide';
import Drawer from '@mui/material/Drawer';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService';
import Button from '@mui/material/Button';
import { Link } from 'react-router-dom';
import PickupRequestDetail from './PickupRequestDetail'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import OrderListTable from './OrderListTable';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ConfirmDialog from '../Modals/ConfirmDialog';
import OrderMapView from './OrderMapView';
import dayjs from 'dayjs';
import cloneDeep from 'lodash/cloneDeep';

function AvailableOrders(props) {
    const [isFetching, setIsFetching] = React.useState(true);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const [orders, setOrders] = React.useState([]);
    const [selectedOrder, setSelectedOrder] = React.useState(null);
    const containerRef = React.useRef(null);
    React.useEffect(() => {
        loadOrders(); // only called once
    }, []);

    function loadOrders() {
        setIsFetching(true);
        let postData = {
            version:'2.0'
        } 
        TokenService.post(postData, 'Get_OpenOrders')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    let jsonData = JSON.parse(response.JsonData);
                    let tempOrders = jsonData.Orders;

                    if (tempOrders != '') {
                        tempOrders = JSON.parse(tempOrders);
                    }

                    let userLevel = jsonData.ReturnerLevel;
                    if (userLevel != '') {
                        userLevel = JSON.parse(userLevel);
                    }
                    props.userLevelUpdated(userLevel);

                    setOrders(tempOrders);
                    setIsFetching(false);
                }
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });
    }

    function buildSkeleton() {
        return <div>
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
            <Skeleton variant="text" sx={{ fontSize: '2rem', marginRight: 'auto', marginLeft: 'auto' }} width={'90%'} />
        </div>
    }

    function buildOrders() {
        if (props.userLevel != null && props.userLevel.TrainingChecklist.RemainingItemCount > 0) {
            return <div>
                <div style={{backgroundColor:'var(--sipzee-gray-2)', color:'var(--sipzee-green)', fontSize:'22pt', fontWeight:'bold'} }>Welcome to Sipzee!</div>
                <div>
                    Before you can start viewing orders, you have to complete a short Account Setup Checklist.
                </div>
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    <Button
                        component={Link}
                        to='/MyAccount'
                        style={{ alignSelf: 'center', maxWidth: '225px' }}
                        sx={{ my: 2, display: 'flex', background: 'var(--sipzee-green)' }}
                    >My Account
                    </Button>
                </div>
            </div>
        }
        else if (orders.length == 0) {
            return <div>
                There are currently no pickup requests in your service area.
                You can expand your service region anytime by adding more service areas to your profile in
                <div style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                    <Button
                        component={Link}
                        to='/MyAccount'
                        style={{ alignSelf: 'center', maxWidth: '225px' }}
                        sx={{ my: 2, display: 'flex', background: 'var(--sipzee-green)' }}
                    >My Account
                    </Button>
                    <div>
                        {(props.loggedInUser.EmailPreferences == 'Immediate' || props.loggedInUser.SMS_NewPickups) ?
                            <div>
                                You will be notified by
                                {props.loggedInUser.EmailPreferences == 'Immediate' ? ' Email ' : null}
                                {(props.loggedInUser.EmailPreferences == 'Immediate' && props.loggedInUser.SMS_NewPickups) ? 'and' : null}
                                {props.loggedInUser.SMS_NewPickups ? ' Text ' : null}
                                when new requests in your service area become available.
                            </div>
                            :
                            <div>
                                If you set your <span style={{ fontWeight: 'bold' }} >Emails for new pickups</span> to <span style={{ fontWeight: 'bold' }} >Immediate</span> or <span style={{ fontWeight: 'bold' }} >enable Text alerts</span>, you will recieve an alert when new requests in your area become available.
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        else {
            return <OrderListTable Orders={orders} loggedInUser={props.loggedInUser} Section='Available' OrderSelected={handleOrderSelected} />
        }
    }

    function buildMap() {
        if (orders.length == 0) {
            return null;
        }
        else {
            return (
                <Card style={{ display: (selectedOrder == null ? 'block' : 'none') }} sx={{ minWidth: 300, maxWidth: 600, width: '100%', alignSelf: 'center', margin: '0px', padding: '0px', marginTop: '10px' }}>
                    <CardContent style={{ padding: '5px' }}>
                        <div style={{ fontSize: '10pt' }}>Map pins are approximate locations</div>
                        <OrderMapView Orders={orders} loggedInUser={props.loggedInUser} Section='Available' OrderSelected={handleOrderSelected} />
                    </CardContent>
                </Card>)
        }
    }

    function handleCloseDetail() {
        setSelectedOrder(null);
    }

    function handleOrderSelected(order) {
        if (order.FirstViewed == null) {
            order.FirstViewed = dayjs().format('MM-DD-YYYY hh:mm a');
            let tempOrders = cloneDeep(orders);
            for (let i = 0; i < tempOrders.length; i++) {
                if (tempOrders[i].OrderGUID == order.OrderGUID) {
                    tempOrders[i] = order;
                    break;
                }
            }
            setOrders(tempOrders);
        }
        setSelectedOrder(order);
    }

    function handleRequestScheduled(pickupRequest, selectedDate, selectedTime, claimToken) {
        //alert('handleRequestScheduled: ' + pickupRequest.RequestID + " on " + selectedDate + " at " + selectedTime);
        setIsFetching(true);
        let postData = {
            OrderGUID: pickupRequest.OrderGUID,
            ReturnerPickUpDate: selectedDate,
            ReturnerPickUpWindow: selectedTime,
            claimToken: claimToken == null ? '' : claimToken.ClaimToken
        }
        TokenService.post(postData, 'UpdateOrder')
            .then((response) => {
                response = response[Object.keys(response)[0]];
                if (response.Result == "SUCCESS") {
                    enqueueSnackbar("This order has been moved to your 'My Open Orders'", {
                        variant: 'success',
                    });

                    props.orderMoved('AvailableOrders', 'OpenOrders');

                    if (props.loggedInUser.CompletedOrders == 0) {
                        // show a Dialog Congratulations and what's next
                    }
                }
                else {
                    enqueueSnackbar(response.Message, {
                        variant: 'error',
                    });  
                }
                loadOrders();
            })
            .catch((response) => {
                enqueueSnackbar('Oops, something went wrong', {
                    variant: 'error',
                });
            });

        window.setTimeout(function () {
            setSelectedOrder(null); // add a little delay to so the slide animation looks more natural
        }, 400);
        
    }

    return (
        

        <div style={{ display: 'flex', justifyContent: 'center', flexDirection:'column' }}>
            <Card sx={{ minWidth: 300, maxWidth: 600, width: '100%', alignSelf: 'center', margin: '0px', padding: '0px' }}
            ref={containerRef}>
                    <CardContent style={{ padding: '5px' }}>
                    <Slide direction="right" in={selectedOrder === null} mountOnEnter unmountOnExit >
                        <div>
                            {
                                (props.isFetching || isFetching)
                                    ? buildSkeleton() : buildOrders()
                            }
                        </div>
                    </Slide>
                    

                    <Slide direction="left" in={selectedOrder !== null} mountOnEnter unmountOnExit >
                        <div>
                            <PickupRequestDetail
                                PickupRequest={selectedOrder}
                                onBack={() => setSelectedOrder(null)}
                                loggedInUser={props.loggedInUser}
                                onScheduled={handleRequestScheduled}
                            />
                        </div>
                    </Slide>
                        
                </CardContent>
            </Card>
            {
                (props.isFetching || isFetching)
                    ? null :
                    buildMap()
            }
        </div>

           
        
    );
}

export default AvailableOrders;